Ext.ns('mx.plugin');

mx.plugin.Constraint = function(/*Object config*/ config) {
    Ext.apply(this, config);
};

Ext.extend(mx.plugin.Constraint, Ext.util.Observable, {
    init: function(/*Ext.Panel*/ panel) {
        panel.constraint = {
            minWidth: this.minWidth || 0,
            autoHeight: this.autoHeight === true,
            scrollbarWidth: mx.plugin.Constraint.getScrollbarWidth(),
        };

        panel.on('render', function(panel) {
            panel.constraintDiv = panel.body.wrap({
                tag: 'div',
                style:
                    'position: relative; overflow: auto;' + (panel.constraint.autoHeight ? ' overflow-y: hidden;' : ''),
            });
        });

        panel.on('bodyresize', function(panel, w, h) {
            if (w) {
                panel.constraintDiv.setWidth(w - panel.getFrameWidth());
            }
            if (h) {
                panel.constraintDiv.setHeight(h - panel.getFrameHeight());
            }
        });

        Ext.apply(panel, {
            adjustBodyWidth: function(width) {
                var result = width;
                if (typeof width == 'number') {
                    if (width < panel.constraint.minWidth) {
                        result = panel.constraint.minWidth;
                    }
                    if (!panel.constraint.autoHeight) {
                        result -= panel.constraint.scrollbarWidth;
                    }
                }
                return result;
            },

            adjustBodyHeight: function() {
                return 'auto';
            },
        });
    },
});

// static function
mx.plugin.Constraint.getScrollbarWidth = function() {
    if (!window.SCROLL_BAR_WIDTH) {
        if (Ext.isIE) {
            var textarea1 = Ext.DomHelper.insertFirst(
                Ext.getBody(),
                '<textarea cols="10" rows="2" style="position: absolute, top: -1000px, left: -1000px;"></textarea>',
                true
            );
            var textarea2 = Ext.DomHelper.insertFirst(
                Ext.getBody(),
                '<textarea cols="10" rows="2" style="position: absolute, top: -1000px, left: -1000px; overflow: hidden;"></textarea>',
                true
            );
            window.SCROLL_BAR_WIDTH = textarea1.getWidth() - textarea2.getWidth();
            textarea1.remove();
            textarea2.remove();
        } else {
            var div1 = Ext.DomHelper.insertFirst(
                Ext.getBody(),
                '<div style="position: absolute, top: -1000px, left: -1000px; width: 100px; height: 100px; overflow: auto;"></div>',
                true
            );
            var div2 = Ext.DomHelper.insertFirst(div1, '<div style="width: 100%; height: 200px"></div>', true);
            window.SCROLL_BAR_WIDTH = 100 - div2.getWidth();
            div2.remove();
            div1.remove();
        }
    }
    return window.SCROLL_BAR_WIDTH;
};
